import { ModuleCompetitorComparisonTableFragment } from '@/graphql';
import { FC, ReactNode } from 'react';
import CompetitorComparisonTable from '@/components/tables/CompetitorComparisonTable';
import { getSingle } from '@/lib/typescript-helpers';
import Image from '@/components/Image';

interface CompetitorComparisonTableModuleProps {
  props: CraftModuleFragment<ModuleCompetitorComparisonTableFragment>;
}

const CompetitorComparisonTableModule: FC<CompetitorComparisonTableModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  let competitorLogo: ReactNode | undefined;

  const logo = getSingle(props.competitorLogo);

  if (logo) {
    competitorLogo = <Image src={logo.url!} width={logo.width ?? 0} height={logo.height ?? 0} alt="" />;
  }

  return (
    <CompetitorComparisonTable
      heading={props.heading ?? ''}
      frontDescription={props.frontDescription ?? ''}
      competitorName={props.competitorName ?? ''}
      competitorDescription={props.competitorDescription ?? ''}
      competitorLogo={competitorLogo}
      frontRows={
        props.features?.map((row) => ({
          enabled: row?.enabledForFront === '1' ?? true,
          text: row?.front ?? '',
        })) ?? []
      }
      competitorRows={
        props.features?.map((row) => ({
          enabled: row?.enabledForCompetitor === '1' ?? false,
          text: row?.competitor ?? '',
        })) ?? []
      }
    />
  );
};

export default CompetitorComparisonTableModule;
